/**
 * Language Configuration
 * This file is auto-generated based on the LANGUAGE environment variable
 * Used to configure the site language
 * 
 * Generated at: 2026-03-30T14:20:25.104Z
 */

// Language code from environment variable (set at build time)
export const LANGUAGE = 'en'

export default LANGUAGE
